import './Video.css';
import VideoPlayer from './VideoPlayer';
import './VideoPlayer.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import productVideo from '../assets/product_video.mp4';
import i18n from '../i18n';



export default function Video() {
    const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
    const { t } = useTranslation();
    const navigate = useNavigate();

    function handleAccountEnter() {
        window.open(`/login`, '_blank', 'noopener,noreferrer');
    }

    return(
        <section className='mx-auto py-16 px-[20px] sm:px-[100px] lg:px-[200px]' id='video-section'>
            <div className='w-full flex flex-col gap-[16px] items-center justify-center m-auto'>
                <VideoPlayer videoMaterial={productVideo} />
                <button className='cases-title-bttn' onClick={handleAccountEnter}>
                        {t('$Buttom3')}
                </button>
            </div>
        </section>
    );
}